//import "@fancyapps/ui/dist/carousel/carousel.umd.js";
//import $ from "jquery";
/**
 * Mobile navigation toggle
 * @param {mixed} event
 */

//$(document).ready(function () {
//alert("ready");
// $(".location-heading").on("click", function () {
// 	console.log("clicked");
// 	$(this).next().slideToggle();
// 	$(this).toggleClass("active");
// });
// });

import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.esm.js";
import "@fancyapps/ui/dist/carousel/carousel.css";

const menuButton = document.querySelector(".js-menu-toggle");
if (menuButton) {
	menuButton.addEventListener("click", function (event) {
		//alert("toggleMenu");
		console.log(event);
		event.preventDefault();
		menuButton.classList.toggle("open");
		document.body.classList.toggle("menu-open");
		document.querySelector(".header__navigation").classList.toggle("open");
	});
}

// $(document).ready(function () {
// 	$(".location-heading").on("click", function () {
// 		console.log("clicked");
// 		$(this).next().slideToggle();
// 		$(this).toggleClass("active");
// 	});
// });

const locationBlocks = document.querySelectorAll(".location-block");
if (locationBlocks) {
	locationBlocks.forEach((locationBlock, index) => {
		if (index === 0) {
			locationBlock.classList.add("active");
		}
		const locationHeading = locationBlock.querySelector(".location-heading");
		locationHeading.addEventListener("click", function () {
			locationBlock.classList.toggle("active");
		});
	});
}

const scrollToButtons = document.querySelectorAll(".js-scroll-to");
if (scrollToButtons.length) {
	scrollToButtons.forEach((button) => {
		button.addEventListener("click", function (event) {
			event.preventDefault();
			const target = button
				.querySelector(".wp-element-button")
				.getAttribute("href");
			const targetElement = document.querySelector(target);
			console.log(targetElement);
			targetElement.scrollIntoView({ behavior: "smooth" });
		});
	});
}

const headerScroll = document.querySelectorAll(".header-contact-btn");
if (headerScroll.length) {
	console.log("scrollToButtons");
	headerScroll.forEach((button) => {
		button.addEventListener("click", function (event) {
			console.log(button);
			event.preventDefault();
			const target = button.getAttribute("data-target");
			const targetElement = document.querySelector(target);
			console.log(targetElement);
			targetElement.scrollIntoView({ behavior: "smooth" });
		});
	});
}

const postLists = document.querySelectorAll(".post-list");
if (postLists.length) {
	postLists.forEach((postList) => {
		if (postList.classList.contains("f-carousel")) {
			const carousel = new Carousel(postList, {
				Dots: false,
				slidesPerPage: 1,
				infinite: false,
				Navigation: false,
				breakpoints: {
					"(min-width: 1280px)": {
						enabled: false,
					},
				},
			});
		}
	});
}

(function (root, $, undefined) {
	"use strict";

	$(function () {
		formUpdates();
	});

	function formUpdates() {
		// Update the rootline heading

		$(".frm_rootline_group").each(function () {
			var currentStep = $(this)
				.find(".frm_current_page .frm_rootline_title")
				.text();
			$(this).prepend('<h2 class="rootline-heading">' + currentStep + "</h2>");
		});

		$(document).on("frmPageChanged", function (event, form, response) {
			var formID = $(form).attr("id");
			setTimeout(function () {
				console.log(event, form, response, formID);
			}, 1000);
			var currentForm = $("#" + formID);
			var rootLine = $(currentForm).find(".frm_rootline_group");
			var currentStep = $(rootLine)
				.find(".frm_current_page .frm_rootline_title")
				.text();
			$(currentForm)
				.find(".frm_rootline_group")
				.prepend('<h2 class="rootline-heading">' + currentStep + "</h2>");
		});
	}
})(this, jQuery);
